// extracted by mini-css-extract-plugin
export default {"mainLayout":"style_mainLayout__T3IIo","content":"style_content__EKmm5","white":"style_white__JhSWd","text":"style_text__huop2","buttons":"style_buttons__5u4kY"};